import React, { useState } from 'react';
import './../index.css';
import FilterIcon from '../../../components/Icons/FilterIcon';
import ChangeStore from '../../../components/Topbar/ChangeStore';
import OutlinedBlackBtn from '../../../components/OutlinedBlackBtn';
import StorefrontIcon from '../../../components/Icons/StorefrontIcon';

export const Header = ({
  inventoriesCount = 0,
  onCreatePress,
  onFilterPress,
  hasActiveFilters = false,
  style = {},
}) =>
{
  const isEmpty = inventoriesCount === 0;
  const changeStoreParams = JSON.parse(localStorage.getItem('changeStoreParams'));
  const [selectedPosId, setSelectedPosId] = useState(changeStoreParams?.selectedPosId || '');
  const [openModal, setOpenModal] = useState(false);

  return (
    <header
      className="header"
      style={style}
    >
      <div className="text-container">
        <OutlinedBlackBtn
          title="Change store"
          variant="outlined"
          startIcon={<StorefrontIcon />}
          onClick={() => setOpenModal(true)}
        />
      </div>

      <div className="actions">
        <div
          className="filter"
          onClick={onFilterPress}
          style={{ cursor: 'pointer', ...(hasActiveFilters ? { border: '2px solid #007AFF26', backgroundColor: '#007AFF0A' } : {}) }}
        >
          <FilterIcon/>
        </div>
        <button
          className={`create-button ${isEmpty ? 'create-button--empty' : ''}`}
          onClick={onCreatePress}
        >
          Create Inventory
        </button>
      </div>

      {openModal && (
        <ChangeStore
          open={openModal}
          setOpenModal={setOpenModal}
          handleClose={() => setOpenModal(false)}
          selectedPosId={selectedPosId}
          setSelectedPosId={setSelectedPosId}
        />
      )}
    </header>
  );
};
